/**
 * Restores the saved product-grid density for Blue Zone collection sections.
 * ResultsList owns subsequent density changes and progressive loading.
 */
function initializeBlueZoneCollection(root = document) {
  root.querySelectorAll('.bz-main-collection .product-grid').forEach((grid) => {
    if (!(grid instanceof HTMLElement) || grid.dataset.bzGridInitialized === 'true') return;

    grid.dataset.bzGridInitialized = 'true';

    const viewport = window.matchMedia('(min-width: 750px)').matches ? 'desktop' : 'mobile';
    let storedLayout = null;

    try {
      storedLayout = sessionStorage.getItem(`product-grid-view-${viewport}`);
    } catch (error) {
      storedLayout = null;
    }

    if (!storedLayout) return;

    const section = grid.closest('.bz-main-collection');
    const options = section?.querySelectorAll('input[type="radio"][name="grid"]') ?? [];

    grid.setAttribute('product-grid-view', storedLayout);

    options.forEach((option) => {
      if (option instanceof HTMLInputElement) {
        option.checked = option.value === storedLayout;
      }
    });
  });
}

initializeBlueZoneCollection();

document.addEventListener('shopify:section:load', (event) => {
  initializeBlueZoneCollection(event.target);
});
